type AccountAvatarSource = {
  imageUrl?: string | null;
  avatar?: string | null;
};

// Busca la URL disponible para mostrar el avatar de la cuenta/persona.
export const getAccountAvatarSrc = (account?: AccountAvatarSource | null): string | undefined => {
  const src = account?.imageUrl || account?.avatar || "";

  return src.trim() || undefined;
};
